import { render, staticRenderFns } from "./FrsHeterogenityDisplay.vue?vue&type=template&id=1f6ddfea&scoped=true&lang=html&"
import script from "./FrsHeterogenityDisplay.vue?vue&type=script&lang=js&"
export * from "./FrsHeterogenityDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ddfea",
  null
  
)

export default component.exports